module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/custom.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Fasting for Miracles")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "acknowledgments"
    }
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#t1",
      "id": "c1"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOULD LIKE")]), _vm._v(" to acknowledge the following people who have made this book possible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Lori DeAngelo and Lisa Haines, thank you for your friendship and dedication to helping me edit this book. You have always been there for me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Diane Campos, thank you for your eye for detail and passion and love for the Lord Jesus Christ. You truly are a gift.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Phil Hotsenpiller, my wonderful husband, you have been my greatest encourager. Thank you for always challenging me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Influence Church, you are the reason I am where I am today. My prayer and fasting life have grown because of you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Charisma House, it has been an honor and a privilege to work with you. Your professionalism and commitment to this project have been a blessing to me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0